export * from "./Mc2PointsSelect";
